import React from 'react';
import { FormInput, FormInputProps } from 'modules';

export const ExpenseOther = 'Iné';

const expenseTypes = [
  'Nájomné',
  'Energie – služby',
  'Potraviny - strava',
  'Ošatenie',
  'Telefón – internet',
  'Cestovné',
  'Splátky Hypo, Leasingu',
  'Lieky - lekár',
  'Škôlka/škola',
  'Výživné',
  'Dôchodkové sporenie',
  ExpenseOther,
];

export const isExpenseOther = (expense: string) =>
  expense !== '' && (!expenseTypes.includes(expense) || expense === ExpenseOther);

const ExpenseSelect = (props: FormInputProps) => {
  const options = expenseTypes.map((expense: string) => ({
    value: expense,
    label: expense,
  }));

  return <FormInput {...props} type={'select'} options={options} />;
};

export default ExpenseSelect;
